'use strict';

export default class ArchiveLandingPages {
    constructor() {
        this.filters = Array.from(document.querySelectorAll('.archive-landing-pages--filter'));

        if (!this.filters.length) {
            return;
        }

        this.filters.forEach((filter) => {
            filter.addEventListener('toggle', () => {
                if (filter.open) {
                    this.closeOthers(filter);
                }
            });
        });

        document.addEventListener('click', (event) => {
            this.filters.forEach((filter) => {
                if (filter.open && !filter.contains(event.target)) {
                    filter.open = false;
                }
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.closeAll();
            }
        });
    }

    closeOthers(current) {
        this.filters.forEach((filter) => {
            if (filter !== current) {
                filter.open = false;
            }
        });
    }

    closeAll() {
        this.filters.forEach((filter) => {
            filter.open = false;
        });
    }
}
